import { render, staticRenderFns } from "./sidepane.vue?vue&type=template&id=6db3953c&scoped=true&lang=pug"
import script from "./sidepane.vue?vue&type=script&lang=js"
export * from "./sidepane.vue?vue&type=script&lang=js"
import style0 from "./sidepane.vue?vue&type=style&index=0&id=6db3953c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db3953c",
  null
  
)

export default component.exports